import { render, staticRenderFns } from "./submission-information.vue?vue&type=template&id=1af3b21a"
import script from "./submission-information.vue?vue&type=script&lang=js"
export * from "./submission-information.vue?vue&type=script&lang=js"
import style0 from "./submission-information.vue?vue&type=style&index=0&id=1af3b21a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports